"use client";

import { cn } from "./utils";

function Slider({
  className,
  value,
  onValueChange,
  min = 0,
  max = 100,
  step = 1,
  ...props
}: {
  className?: string;
  value: number[];
  onValueChange: (val: number[]) => void;
  min?: number;
  max?: number;
  step?: number;
}) {
  return (
    <input
      type="range"
      className={cn("form-range w-100", className)}
      min={min}
      max={max}
      step={step}
      value={value[0]}
      onChange={e => onValueChange([Number(e.target.value)])}
      {...props}
    />
  );
}

export { Slider };
